import { Button, Fade, Tooltip } from '@material-ui/core'
import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'

import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import './ProductCard.css'
import FavouriteCheckbox from '@/product/components/atoms/FavoriteCheckbox'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import Bidding from '@/custom/components/molecules/Bidding/BiddingItem'
import Buynow from '@/custom/components/molecules/Buynow/BuynowItem'
import { dateFormatFront } from '@/custom/common/components'
import { handleRedirectInternal, currencyFormat } from '@/custom/common/components'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
// import Timer from '@/product/common/timer'
import Timer from '@/custom/common/timer'
import BidHistory from '../../organisms/BidHistory'
import { FALLBACK_IMAGE } from '@/utils'
import ReverseBidding from '@/custom/components/molecules/Reverse/Bidding/BiddingItem'
import ProductContext from '@/product/context/product/productContext'

const Grid = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const customCommonContext = useContext(CustomCommonContext)

    const { setBidHistoryValue } = commonContext
    const { user, isAuthenticated } = authContext
    const { configVariables } = customCommonContext

    const [product, setProduct] = useState()
    const [highBid, setHighBid] = useState()
    const [accessUpdate, setAccessUpdate] = useState(false)
    const history = useHistory()
    useEffect(() => {
        if (props.data) {
            if (props.data.selectedbuyer && props.data.selectedbuyer !== '') {
                if (!Array.isArray(props.data.selectedbuyer)) {
                    props.data.selectedbuyer = props.data.selectedbuyer.split(',')
                }
                console.log(props.data.selectedbuyer, 'selectt')
            }
            setProduct(props.data)
        }
    }, [props.data])

    const updateBid = (data) => {
        if (data) {
            setHighBid(data[0].user_id)
        }
    }

    const requestupdate = (product) => {
        props.requestfunc(product)
    }

    useEffect(() => {
        setAccessUpdate(product?.accessUpdate ? true : false)
    }, [product?.accessUpdate])

    return (
        <Fade in={true} timeout={600}>
            <div className="productCardGrid">
                {product ? (
                    <>
                        <div className="pcgImg">
                            <FavouriteCheckbox
                                watchlisted={product.watchlistid}
                                project_id={product.id}
                            />
                            <img
                                className="cursorDecoy"
                                // onClick={props.drawerHandler}
                                src={`${global.site_url}/uploads/product/${product.avatar}`}
                                onClick={() => {
                                    handleRedirectInternal(history, `productView/${product.id}`)
                                }}
                                onError={(e) => FALLBACK_IMAGE(e)}
                                alt={product.title}
                            />
                            {isAuthenticated && (
                                <>
                                    {product.bidtopstatus === 'outbid' && (
                                        <h4 className="productWinningStatus outbid" id="bts_Outbid">
                                            {product.wprice < product.rprice
                                                ? 'Reserve not met'
                                                : 'Outbid'}
                                        </h4>
                                    )}
                                    {product.bidtopstatus === 'winner' && (
                                        <h4
                                            className="productWinningStatus winning"
                                            id="bts_Winning"
                                        >
                                            {product.wprice < product.rprice
                                                ? 'Reserve not met'
                                                : 'Winning'}
                                        </h4>
                                    )}
                                    {product.bidtopstatus === 'won' && (
                                        <h4 className="productWinningStatus won" id="bts_Won">
                                            {'Won'}
                                        </h4>
                                    )}
                                    {product.bidtopstatus === 'lost' && (
                                        <h4 className="productWinningStatus lost" id="bts_Lost">
                                            {'Lost'}
                                        </h4>
                                    )}

                                    {/* {(product.bidtopstatus === 'outbid' ||
                                        product.bidtopstatus === 'winner') &&
                                        product.wprice <= product.rprice && (
                                            <>
                                                <Tooltip title="Reserve price not met">
                                                    <span className="material-icons reserveNotMet">
                                                        lock_open
                                                    </span>
                                                </Tooltip>
                                            </>
                                        )} */}
                                </>
                            )}
                        </div>

                        <h2
                            className="gridProdTitle"
                            // onClick={props.drawerHandler}
                            onClick={() => {
                                handleRedirectInternal(history, `productView/${product.id}`)
                            }}
                            id="grid_product_title"
                        >
                            {product.title}
                        </h2>
                        {/* <div className="gridLotDetails d-flex justify-content-start align-items-center">
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: product.desc_proc,
                                }}
                            ></p>
                        </div> */}

                        {/* <div className="gridBidInfo d-flex justify-content-between align-items-center">
                            <h6>{t('auction')} id:</h6>
                            <p>
                                <span>{`#${product.auctionid}`}</span>
                            </p>
                        </div> */}

                        {console.log(product, '===>')}

                        {product.market_status === 'open' ? (
                            <div
                                className={`bidQuator ${
                                    (product.auction && product.buynow && '') ||
                                    (!product.auction && product.buynow && 'onyByn') ||
                                    (product.auction && !product.buynow && 'onyAuc')
                                }`}
                            >
                                {product.auction ? (
                                    <div className="iconDivion">
                                        <svg
                                            width="35"
                                            height="29"
                                            viewBox="0 0 35 29"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M20.1174 5.49125C20.755 6.12887 20.7688 7.15738 20.1451 7.78114L19.8096 8.11658L22.5126 10.7752L15.6762 17.3648L13.0426 14.6369L2.77689 24.9026C2.15591 25.5236 1.12463 25.5125 0.487006 24.8749C-0.150613 24.2373 -0.164474 23.2088 0.459284 22.585L10.7638 12.2805L8.70121 10.1376L15.1633 3.54513L17.4782 5.81561L17.833 5.46076C18.4512 4.83977 19.4797 4.85363 20.1174 5.49125ZM34.0646 27.6915C34.0646 28.4095 33.4935 28.9972 32.7921 28.9972L18.0964 29C17.395 29 16.8239 28.4123 16.8239 27.6943C16.8239 26.9901 17.3839 26.3885 18.0964 26.3885H19.6627C19.2691 26.1668 19.0001 25.7371 19.0001 25.2436C19.0001 24.5394 19.5601 23.9379 20.2726 23.9379H30.6131C31.3145 23.9351 31.8884 24.5228 31.8884 25.2408C31.8884 25.7343 31.6167 26.1668 31.2203 26.3885H32.7894C33.4935 26.3858 34.0646 26.9735 34.0646 27.6915ZM14.8806 0.387526C15.3879 0.89485 15.399 1.71544 14.9027 2.2089L7.36221 9.74944C6.86597 10.2457 6.04816 10.2346 5.54083 9.72726C5.03351 9.21994 5.02242 8.39935 5.51865 7.90589L13.0592 0.365348C13.5554 -0.130886 14.3732 -0.119797 14.8806 0.387526ZM25.6009 11.1051C26.1082 11.6124 26.1193 12.433 25.6231 12.9264L18.0825 20.467C17.5863 20.9632 16.7685 20.9521 16.2612 20.4448C15.7538 19.9375 15.7427 19.1169 16.239 18.6234L23.7795 11.0829C24.273 10.5867 25.0908 10.5978 25.6009 11.1051Z"
                                                fill="black"
                                            />
                                        </svg>
                                        <div className="gridBidInfo">
                                            <h6>Current Bid</h6>
                                            {product.auction ? (
                                                <p className="d-flex justify-content-between align-items-center">
                                                    <span>{currencyFormat(product.wprice)}</span>
                                                </p>
                                            ) : (
                                                <p className="notAvailable">
                                                    <span>{'Not available'}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                                {product.buynow ? (
                                    <div className="iconDivion">
                                        <svg
                                            width="26"
                                            height="29"
                                            viewBox="0 0 26 29"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1.20345 7.07209H6.69101V5.98672C6.72346 4.38818 7.40035 2.86575 8.57632 1.74638C9.75229 0.627014 11.3335 0 12.9805 0C14.6274 0 16.2087 0.627014 17.3846 1.74638C18.5606 2.86575 19.2375 4.38818 19.2699 5.98672V7.07209H24.8014C24.9589 7.07252 25.1148 7.10309 25.2602 7.16205C25.4055 7.22102 25.5375 7.30721 25.6485 7.41572C25.7602 7.52388 25.8488 7.65243 25.9091 7.79397C25.9694 7.93551 26.0003 8.08724 26 8.24041V24.8054C25.9968 25.9169 25.5405 26.982 24.7309 27.768C23.9213 28.5539 22.8242 28.9969 21.6793 29H4.32072C3.17621 28.9969 2.07945 28.5543 1.26993 27.7688C0.4604 26.9834 0.00386427 25.9189 0 24.8078L0 8.24278C0.000120603 8.08946 0.0314534 7.93767 0.0921976 7.79614C0.152942 7.65461 0.241899 7.52613 0.353957 7.41809C0.464962 7.30958 0.596909 7.22339 0.742254 7.16442C0.887599 7.10546 1.04349 7.07489 1.20101 7.07446L1.20345 7.07209ZM8.22402 7.07209H17.7442V5.98672C17.7442 4.76112 17.2427 3.58571 16.35 2.71908C15.4573 1.85245 14.2466 1.36558 12.9841 1.36558C11.7217 1.36558 10.5109 1.85245 9.61822 2.71908C8.72553 3.58571 8.22402 4.76112 8.22402 5.98672V7.07209ZM6.69101 10.1529V8.56034H1.533V23.2532H24.4792V8.56034H19.2699V10.1623C19.5733 10.333 19.8097 10.5966 19.9419 10.9118C20.0742 11.227 20.0948 11.576 20.0006 11.9038C19.9064 12.2316 19.7027 12.5198 19.4214 12.723C19.1401 12.9262 18.7973 13.033 18.4468 13.0265C18.0962 13.02 17.7579 12.9006 17.4848 12.6871C17.2117 12.4736 17.0195 12.1781 16.9382 11.847C16.857 11.5159 16.8913 11.168 17.0359 10.8579C17.1805 10.5478 17.4271 10.2931 17.7369 10.1339V8.56034H8.21669V10.1505C8.52339 10.3154 8.76496 10.5746 8.90343 10.8873C9.0419 11.2 9.06942 11.5485 8.98168 11.8781C8.89394 12.2076 8.69591 12.4995 8.4187 12.7079C8.14149 12.9163 7.80081 13.0294 7.45019 13.0294C7.09958 13.0294 6.7589 12.9163 6.48169 12.7079C6.20447 12.4995 6.00644 12.2076 5.9187 11.8781C5.83096 11.5485 5.85849 11.2 5.99696 10.8873C6.13543 10.5746 6.37699 10.3154 6.68369 10.1505L6.69101 10.1529Z"
                                                fill="black"
                                            />
                                        </svg>
                                        <div className="gridBidInfo">
                                            <h6>{'Buy it now'}</h6>
                                            {product.buynow && product.wprice < product.bprice ? (
                                                <p className="d-flex justify-content-between align-items-center">
                                                    <span>{currencyFormat(product.bprice)}</span>
                                                </p>
                                            ) : (
                                                <p className="notAvailable">
                                                    <span>{'NA'}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div className="bidQuator onlySold">
                                <div className="iconDivion">
                                    <svg
                                        width="26"
                                        height="29"
                                        viewBox="0 0 26 29"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.20345 7.07209H6.69101V5.98672C6.72346 4.38818 7.40035 2.86575 8.57632 1.74638C9.75229 0.627014 11.3335 0 12.9805 0C14.6274 0 16.2087 0.627014 17.3846 1.74638C18.5606 2.86575 19.2375 4.38818 19.2699 5.98672V7.07209H24.8014C24.9589 7.07252 25.1148 7.10309 25.2602 7.16205C25.4055 7.22102 25.5375 7.30721 25.6485 7.41572C25.7602 7.52388 25.8488 7.65243 25.9091 7.79397C25.9694 7.93551 26.0003 8.08724 26 8.24041V24.8054C25.9968 25.9169 25.5405 26.982 24.7309 27.768C23.9213 28.5539 22.8242 28.9969 21.6793 29H4.32072C3.17621 28.9969 2.07945 28.5543 1.26993 27.7688C0.4604 26.9834 0.00386427 25.9189 0 24.8078L0 8.24278C0.000120603 8.08946 0.0314534 7.93767 0.0921976 7.79614C0.152942 7.65461 0.241899 7.52613 0.353957 7.41809C0.464962 7.30958 0.596909 7.22339 0.742254 7.16442C0.887599 7.10546 1.04349 7.07489 1.20101 7.07446L1.20345 7.07209ZM8.22402 7.07209H17.7442V5.98672C17.7442 4.76112 17.2427 3.58571 16.35 2.71908C15.4573 1.85245 14.2466 1.36558 12.9841 1.36558C11.7217 1.36558 10.5109 1.85245 9.61822 2.71908C8.72553 3.58571 8.22402 4.76112 8.22402 5.98672V7.07209ZM6.69101 10.1529V8.56034H1.533V23.2532H24.4792V8.56034H19.2699V10.1623C19.5733 10.333 19.8097 10.5966 19.9419 10.9118C20.0742 11.227 20.0948 11.576 20.0006 11.9038C19.9064 12.2316 19.7027 12.5198 19.4214 12.723C19.1401 12.9262 18.7973 13.033 18.4468 13.0265C18.0962 13.02 17.7579 12.9006 17.4848 12.6871C17.2117 12.4736 17.0195 12.1781 16.9382 11.847C16.857 11.5159 16.8913 11.168 17.0359 10.8579C17.1805 10.5478 17.4271 10.2931 17.7369 10.1339V8.56034H8.21669V10.1505C8.52339 10.3154 8.76496 10.5746 8.90343 10.8873C9.0419 11.2 9.06942 11.5485 8.98168 11.8781C8.89394 12.2076 8.69591 12.4995 8.4187 12.7079C8.14149 12.9163 7.80081 13.0294 7.45019 13.0294C7.09958 13.0294 6.7589 12.9163 6.48169 12.7079C6.20447 12.4995 6.00644 12.2076 5.9187 11.8781C5.83096 11.5485 5.85849 11.2 5.99696 10.8873C6.13543 10.5746 6.37699 10.3154 6.68369 10.1505L6.69101 10.1529Z"
                                            fill="black"
                                        />
                                    </svg>
                                    <div className="gridBidInfo d-flex align-items-center justify-content-between">
                                        <h6>{product.cbidtext}</h6>
                                        {product.auction ? (
                                            <p className="d-flex justify-content-between align-items-center">
                                                <span>{currencyFormat(product.wprice)}</span>
                                                {/* <span className="gridDivider">|</span> */}
                                            </p>
                                        ) : (
                                            <p className="d-flex justify-content-between align-items-center">
                                                <span>{currencyFormat(product.buynowamount)}</span>
                                                {/* <span className="gridDivider">|</span> */}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {/* <div className="iconDivion">
                                        <svg
                                            width="26"
                                            height="29"
                                            viewBox="0 0 26 29"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1.20345 7.07209H6.69101V5.98672C6.72346 4.38818 7.40035 2.86575 8.57632 1.74638C9.75229 0.627014 11.3335 0 12.9805 0C14.6274 0 16.2087 0.627014 17.3846 1.74638C18.5606 2.86575 19.2375 4.38818 19.2699 5.98672V7.07209H24.8014C24.9589 7.07252 25.1148 7.10309 25.2602 7.16205C25.4055 7.22102 25.5375 7.30721 25.6485 7.41572C25.7602 7.52388 25.8488 7.65243 25.9091 7.79397C25.9694 7.93551 26.0003 8.08724 26 8.24041V24.8054C25.9968 25.9169 25.5405 26.982 24.7309 27.768C23.9213 28.5539 22.8242 28.9969 21.6793 29H4.32072C3.17621 28.9969 2.07945 28.5543 1.26993 27.7688C0.4604 26.9834 0.00386427 25.9189 0 24.8078L0 8.24278C0.000120603 8.08946 0.0314534 7.93767 0.0921976 7.79614C0.152942 7.65461 0.241899 7.52613 0.353957 7.41809C0.464962 7.30958 0.596909 7.22339 0.742254 7.16442C0.887599 7.10546 1.04349 7.07489 1.20101 7.07446L1.20345 7.07209ZM8.22402 7.07209H17.7442V5.98672C17.7442 4.76112 17.2427 3.58571 16.35 2.71908C15.4573 1.85245 14.2466 1.36558 12.9841 1.36558C11.7217 1.36558 10.5109 1.85245 9.61822 2.71908C8.72553 3.58571 8.22402 4.76112 8.22402 5.98672V7.07209ZM6.69101 10.1529V8.56034H1.533V23.2532H24.4792V8.56034H19.2699V10.1623C19.5733 10.333 19.8097 10.5966 19.9419 10.9118C20.0742 11.227 20.0948 11.576 20.0006 11.9038C19.9064 12.2316 19.7027 12.5198 19.4214 12.723C19.1401 12.9262 18.7973 13.033 18.4468 13.0265C18.0962 13.02 17.7579 12.9006 17.4848 12.6871C17.2117 12.4736 17.0195 12.1781 16.9382 11.847C16.857 11.5159 16.8913 11.168 17.0359 10.8579C17.1805 10.5478 17.4271 10.2931 17.7369 10.1339V8.56034H8.21669V10.1505C8.52339 10.3154 8.76496 10.5746 8.90343 10.8873C9.0419 11.2 9.06942 11.5485 8.98168 11.8781C8.89394 12.2076 8.69591 12.4995 8.4187 12.7079C8.14149 12.9163 7.80081 13.0294 7.45019 13.0294C7.09958 13.0294 6.7589 12.9163 6.48169 12.7079C6.20447 12.4995 6.00644 12.2076 5.9187 11.8781C5.83096 11.5485 5.85849 11.2 5.99696 10.8873C6.13543 10.5746 6.37699 10.3154 6.68369 10.1505L6.69101 10.1529Z"
                                                fill="black"
                                            />
                                        </svg>
                                        <div className="gridBidInfo d-flex justify-content-between align-items-center"></div>
                                    </div> */}
                            </div>
                        )}

                        {/* Timer Auction */}
                        <div className="d-flex justify-content-between align-items-center">
                            {product.market_status === 'open' ? (
                                <div className="gridTimer">
                                    {product.date_closed ? (
                                        <Timer
                                            date_added={product.date_added}
                                            date_closed={product.date_closed}
                                        ></Timer>
                                    ) : null}
                                </div>
                            ) : (
                                <div className="gridTimer d-flex justify-content-start align-items-center">
                                    {/* <h6 className="m-0">{'Closed on'}:</h6> */}
                                    <p className="d-flex align-items-center">
                                        {dateFormatFront(product.date_closed)}
                                    </p>
                                </div>
                            )}
                            <span
                                className="cursorDecoy totalBids"
                                // onClick={() => setBidHistoryValue(product.id)}
                            >
                                {product.bid_count} {'Bids'}
                            </span>
                        </div>

                        {/* Timer Auction */}

                        {/* {props.from === 'dashboard' &&
                        (props.action === 'won' || props.action === 'buynow') &&
                        product.buynowed &&
                        product.buynowed === user.id ? (
                            <div className="actionAfterWin">
                                {parseInt(product.buynowpaid, 10) === 1 ? (
                                    <>
                                        <SecondaryButton
                                            id="invoice_viewed"
                                            label={'View invoice'}
                                            btnSize="small"
                                            onClick={() =>
                                                handleRedirectInternal(
                                                    history,
                                                    `invoice/${product.common_invoice}`,
                                                )
                                            }
                                        />
                                    </>
                                ) : (
                                    <>
                                        <PrimaryButton
                                            id="make_pay_grid"
                                            label={'Make payment'}
                                            btnSize="small"
                                            onClick={() =>
                                                handleRedirectInternal(
                                                    history,
                                                    `checkout/invoice/${product.common_invoice}`,
                                                )
                                            }
                                        />
                                    </>
                                )}
                            </div>
                        ) : product.market_status === 'open' && !product.future_active ? (
                            <>
                                <div className="gridBidBox">
                                    {product.auction ? (
                                        <>
                                            {product.auctiontype == 'reverse' ? (
                                                <ReverseBidding
                                                    data={product}
                                                    type={
                                                        parseInt(
                                                            configVariables?.proxy_bidding_settings,
                                                        ) === 0
                                                            ? 'hard'
                                                            : 'proxy'
                                                    }
                                                />
                                            ) : product.custom_auctionlot_bid_type ? (
                                                <Bidding
                                                    data={product}
                                                    type={`${product.custom_auctionlot_bid_type}`}
                                                />
                                            ) : (
                                                <Bidding data={product} type={'hard'} />
                                            )}
                                        </>
                                    ) : (
                                        <Buynow
                                            data={product}
                                            editQuantity={true}
                                            isOnlyBuynow={product.auction === 0 ? true : false}
                                        />
                                    )}
                                </div>
                            </>
                        ) : product.buynowed && product.buynowed === user.id ? (
                            <div className="actionAfterWin">
                                {parseInt(product.buynowpaid, 10) === 1 ? (
                                    <>
                                        <SecondaryButton
                                            id="invoice_viewed_grid"
                                            label={'View invoice'}
                                            btnSize="small"
                                            onClick={() =>
                                                handleRedirectInternal(
                                                    history,
                                                    `invoice/${product.common_invoice}`,
                                                )
                                            }
                                        />
                                    </>
                                ) : (
                                    <>
                                        <PrimaryButton
                                            id="make_pay_grid"
                                            label={'Make payment'}
                                            btnSize="small"
                                            onClick={() =>
                                                handleRedirectInternal(
                                                    history,
                                                    `checkout/invoice/${product.common_invoice}`,
                                                )
                                            }
                                        />
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="gridBidBox"></div>
                        )} */}

                        <div className="mt-3">
                            {isAuthenticated && product.future_active ? (
                                product?.selectedbuyer?.includes(user?.id.toString()) ? (
                                    <PrimaryButton
                                        className="w-100"
                                        id="view_more_info"
                                        disabled={true}
                                        // onClick={props.drawerHandler}
                                    >
                                        Accepted
                                    </PrimaryButton>
                                ) : accessUpdate ? (
                                    <PrimaryButton
                                        className="w-100"
                                        id="view_more_info"
                                        disabled={true}
                                        // onClick={props.drawerHandler}
                                    >
                                        Rejected
                                    </PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        className="w-100"
                                        id="view_more_info"
                                        onClick={() => {
                                            requestupdate(product)
                                        }}
                                        // onClick={props.drawerHandler}
                                    >
                                        Submit IOI
                                    </PrimaryButton>
                                )
                            ) : (
                                <PrimaryButton
                                    className="w-100"
                                    id="view_more_info"
                                    onClick={() => {
                                        handleRedirectInternal(history, `productView/${product.id}`)
                                    }}
                                    // onClick={props.drawerHandler}
                                >
                                    View Offer
                                </PrimaryButton>
                            )}
                        </div>
                    </>
                ) : null}
            </div>
        </Fade>
    )
}

export default Grid
